module.exports = __webpack_public_path__ + "img/shape-metal_ay@2x.bf9a7376.png";